import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { useAppSelector } from '../../store/hooks';
import { TavernErrorBoundary, TavernToast } from '../../ui/components';
import { checkMiniAppUpdateAndReload } from '../../utils/versionCheck';

import { BottomNav } from './BottomNav';

export function AppShell() {
  const rulesAccepted = useAppSelector((s) => s.app.rulesAccepted);
  const user = useAppSelector((s) => s.auth.user);
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!rulesAccepted && location.pathname !== '/') {
      navigate('/', { replace: true });
    }
  }, [location.pathname, navigate, rulesAccepted]);

  React.useEffect(() => {
    if (rulesAccepted && !user && location.pathname !== '/') {
      navigate('/', { replace: true });
    }
  }, [location.pathname, navigate, rulesAccepted, user]);

  React.useEffect(() => {
    const run = () => {
      void checkMiniAppUpdateAndReload();
    };

    run();

    const onVisibility = () => {
      if (document.visibilityState === 'visible') run();
    };

    const onPageShow = () => {
      run();
    };

    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('pageshow', onPageShow);

    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('pageshow', onPageShow);
    };
  }, []);

  return (
    <div className="ttbShell ttbShellWithNav">
      <TavernToast />
      <main className="ttbShellMain">
        <TavernErrorBoundary>
          <Outlet />
        </TavernErrorBoundary>
      </main>
      <BottomNav disabled={!rulesAccepted} />
    </div>
  );
}
